module.exports = __webpack_public_path__ + "static/media/62.9e8c59c3.gif";